<template>
  <section class="login">
    <div class="top">
      <div class="logo"></div>
    </div>

    <van-form @submit="onSubmit">
      <van-field v-model="username" name="用户名" label="用户名" placeholder="用户名" :rules="[{ required: true, message: '请填写用户名' }]" />
      <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码" :rules="[{ required: true, message: '请填写密码' }]" />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
      <div class="ipv6">
        浙江和烽医药科技有限公司
        <span>支持ipv6</span>
      </div>
    </van-form>
  </section>
</template>
<script>
import { jsencrypt } from '@/modules/js/des'
import { BzAjax, BzJs, BzUser, BzMsg } from '@/modules/js/helper'
const md5 = require('md5')
export default {
  data() {
    return {
      username: '',
      password: '',
    }
  },
  created() {
    var user = BzUser.get()
    if (user.IsLogin == 1) {
      if (user.IsStore == 0) this.$router.push('/home')
      else this.$router.push('/monitorlist/0/' + user.IsStore + '/0')
    }
  },
  methods: {
    onSubmit(values) {
      if (this.username === '' || this.password === '') {
        BzMsg.ShowErr('请输入用户名和密码')
      } else {
        this.loginin()
      }
      //   console.log("submit", values);
    },
    loginin() {
      const username = encodeURIComponent(this.username)
      BzAjax.post('/WSD/Login/GetUser', { LoginID: username })
        .then((data) => {
          let k = md5(this.password).toUpperCase()
          k = k.substring(8, 24)
          k = k + data
          let k5 = md5(k).toUpperCase()
          k5 = k5.substring(8, 24)
          let g = BzJs.guid()
          let g5 = md5(g).toUpperCase()
          g5 = g5.substring(8, 24)
          let s = g5 + ' ' + g
          let sk = jsencrypt(k5, s)
          let LoginID = md5(data).toUpperCase()
          let post_data2 = {
            LoginID: LoginID,
            PassWord: sk,
          }
          BzAjax.post('/WSD/Login/ManageLogin', post_data2)
            .then((d) => {
              var user = {
                sumirryname: d.LoginId,
                sumirrykey: d.Key,
                UserName: d.Name,
                IsLogin: 1,
                IsStore: d.StoreID,
              }
              BzUser.setuser(user)
              if (d.IsStore == 0) this.$router.push('/home')
              else this.$router.push('/monitorlist/0/' + d.StoreID + '/0')
            })
            .catch((d) => {
              BzMsg.ShowErr('账号密码不匹配')
            })
        })
        .catch((d2) => {
          BzMsg.ShowErr('用户不存在')
        })
    },
  },
}
</script>
<style lang="less">
.login {
  .top {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 4.5rem;
    margin-top: 4.5rem;
    .logo {
      background: url('../../modules/assets/logo.jpg') no-repeat;
      background-size: 3.5rem;
      width: 3.5rem;
      height: 3.5rem;
    }
  }
  .ipv6 {
    display: flex;
    justify-content: center;
    width: 100%;
    display: flex;
    text-align: center;
    font-size: 0.7rem;
    span {
      margin-left: 1rem;
      border: 0.01rem solid orangered;
      color: orangered;
      flex-direction: column;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/login.vue